module.exports = "/fonts/vendor/desiigner-svg/svg/fontawesome/light/ballot.svg?c5865d15195f877dc2c7646332af469b";